import styled from 'styled-components';

const SideNavSectionStyled = styled.div`
  display: none;

  @media (min-width: 769px) {
    display: flex;
    flex-direction: column;
    padding-right: 20px;
    width: 36.5%;
    max-width: 380px;
  }
`;

const SideNavMenuStyled = styled.nav`
  background: #2d1540;
  border-radius: 0 0 10px 10px;
  z-index: 999;
`;

export { SideNavSectionStyled, SideNavMenuStyled };
